<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary" @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button class="button btn-danger"
                    v-if="this.element && this.element.id && getPermissionSection('delete')"
                    @click="openConfirmDelete = true">
                {{ $ml.get('buttons.delete') }}
            </button>


            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block" :key="change">
            <div class="title">{{ pageTitle }}</div>
            <div class="body flex-row-wrap">
                <div class="w100">
                    <div class="formBlock">
                        <p class="label">{{ form_labels.photo }}</p>
                        <div class="flex-row flex-space-between">
                            <div class="avatar image-cover" :style="`background-image: url(${photo.url})`"></div>
                            <div class="drag-in-drop"
                                 @dragover="dragoverFile"
                                 @dragleave="dragleaveFile"
                                 @drop="(e) => dropFile(e, 'images')"
                                 @click="$refs.image.click()">
                                <input type="file"
                                       @change="onChangeFile('images')"
                                       ref="image"
                                       accept=".jpeg,.jpg,.png,.gif" />
                                <div class="label">{{ lang.labels.drag_in_drop }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="getClass(key)"
                     :key="label"
                     v-for="(label, key) in labels">
                    <div class="formBlock">
                        <p :class="['label', {'required' : form_required.includes(label)}]">
                            {{ form_labels[label] }}
                            <template v-if="form_required.includes(label)">*</template>
                        </p>
                        <template v-if="getTypeForm(label) === 'number'">
                            <input type="number"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'boolean'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    v-model="element[label]"
                                    :options="selectBooleanOptions"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'string'">
                            <div class="input disabled" v-if="element[label]">{{ element[label] }}</div>
                        </template>
                        <template v-if="getTypeForm(label) === 'date'">
                            <date-picker
                                valueType="format"
                                format="DD.MM.YYYY"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                        </template>
                        <template v-if="getTypeForm(label) === 'link'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'textarea'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'input'">
                            <input type="text"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="getSelectLabel(label)"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-tags'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">{{ lang.labels.how_know }}</div>
            <div class="body">
                <p v-if="!how_know">No data</p>
                <template v-else>
                    <p><b>Sources</b>: {{ how_know.sources.join(', ') }}</p>
                    <p><b>Other</b>: {{ how_know.other ? how_know.other : 'No data' }}</p>
                    <p><b>Additional</b>: {{ how_know.additional ? how_know.additional : 'No data' }}</p>
                </template>
            </div>
        </div>

        <div class="block">
            <div class="title">{{ lang.labels.subscriptions }}</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>{{ lang.labels.date }}</th>
                            <th>{{ lang.labels.braintree_id }}</th>
                            <th>{{ lang.labels.subscription }}</th>
                            <th>{{ lang.labels.plan }}</th>
                            <th>{{ lang.labels.price }}</th>
                            <th>{{ lang.labels.subscription_start }}</th>
                            <th>{{ lang.labels.subscription_end }}</th>
                            <th>{{ 'Cancel' }}</th>
                            <th>{{ 'Cancel date' }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in subscriptions">
                            <td>{{ $func.getDateTime(item.created_at) }}</td>
                            <td>{{ item.braintree_id }}</td>
                            <td>
                                <router-link target="_blank"
                                             class="link"
                                             :to="{name:'subscription.edit', params: {id:item.id}}">
                                    ID {{ item.id }}
                                </router-link>
                            </td>
                            <td>{{ item.plan.title }}</td>
                            <td>{{ item.price }}</td>
                            <td>{{ $func.getDateTime(item.start_at) }}</td>
                            <td>{{ $func.getDateTime(item.ends_at) }}</td>
                            <td>{{ item.cancel ? 'Yes' : '-' }}</td>
                            <td>{{ $func.getDateTime(item.cancel_at) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">{{ lang.labels.gifts }}</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>{{ lang.labels.date }}</th>
                            <th>{{ lang.labels.gift }}</th>
                            <th>{{ lang.labels.recipient }}</th>
                            <th>{{ lang.labels.plan }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in gifts">
                            <td>{{ $func.getDateTime(item.created_at) }}</td>
                            <td>
                                <router-link target="_blank"
                                             class="link"
                                             :to="{ name:'subscription_gift.edit',
                                                    params: { id: item.id }
                                                   }">
                                    ID {{ item.id }}
                                </router-link>
                            </td>
                            <td>{{ item.recipient ? item.recipient.name : item.email }}</td>
                            <td>{{ item.plan.title }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">{{ lang.labels.transactions }}</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>{{ lang.labels.date }}</th>
                            <th>{{ lang.labels.braintree_id }}</th>
                            <th>{{ lang.labels.subscription }}</th>
                            <th>{{ lang.labels.gift }}</th>
                            <th>{{ lang.labels.cost }}</th>
                            <th>{{ lang.labels.card }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in transactions">
                            <td>{{ $func.getDateTime(item.created_at) }}</td>
                            <td>{{ item.braintree_id }}</td>
                            <td>
                                <template v-if="item.subscribe_id">
                                    <router-link target="_blank"
                                                 class="link"
                                                 :to="{ name:'subscription.edit',
                                                    params: {id:item.subscribe_id}
                                                   }">
                                        ID {{ item.subscribe_id }}
                                    </router-link>
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>
                                <template v-if="item.gift_id">
                                    <router-link target="_blank"
                                                 class="link"
                                                 :to="{ name:'subscription_gift.edit',
                                                    params: { id: item.gift_id }
                                                   }">
                                        ID {{ item.gift_id }}
                                    </router-link>
                                </template>
                                <template v-else>-</template>
                            </td>
                            <td>{{ item.cost }}</td>
                            <td>{{ item.card_type }} {{ item.card_mask }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <div class="block">
            <div class="title">Multi account</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>User</th>
                            <th>Expired</th>
                            <th>Actions</th>
                            <th>Created at</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in multi_account">
                            <td>
                                <template v-if="item.recipient">
                                    <router-link target="_blank"
                                                 class="link"
                                                 :to="{ name:'user.edit',
                                                    params: { id: item.recipient.id }
                                                   }">
                                        {{ item.recipient.first_name }} {{ item.recipient.last_name }}
                                        (@{{ item.recipient.name }})
                                    </router-link>
                                </template>
                                <template v-else>
                                    {{ item.email }}
                                </template>
                            </td>
                            <td>{{ $func.getDateTime(item.expired_date) }}</td>

                            <td>
                                <button type="button"
                                        @click="cancelExpireMultiUser(item.id)"
                                        class="button btn-danger"
                                        v-if="item.expired_date">
                                    Cancel expiration date
                                </button>
                                <button type="button"
                                        class="button btn-danger"
                                        @click="deleteMultiUser(item.id)">
                                    Delete
                                </button>
                            </td>
                            <td>{{ $func.getDateTime(item.created_at) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteForm">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>

<script>
import FormMethodsDefault from "../Utils/Page/Form/FormMethodsDefault";
import Table from "../Utils/Table/Table";

export default {
    name: "Form",
    components: {Table},
    mixins: [FormMethodsDefault],
    data() {
        return {
            lang: this.$ml.get('pages.user'),
            buttons: [
            ],

            typeForm: {
                created_at: 'string',
                updated_at: 'string',
                provider: 'string',
                provider_id: 'string',
                type_id: 'select',
                greenhouse: 'boolean',
                is_pro: 'boolean',
                email_notifications: 'select',
            },

            form_required: [
                'name',
                'email'
            ],

            pageRouteList: 'user',
            pageRouteEdit: 'user.edit',
            pageApi: 'user',
            pagePermission: 'user',

            photo: {
                url: null,
            },

            transactions: [],
            subscriptions: [],
            gifts: [],
            multi_account: [],
            how_know: null,
        }
    },
    methods: {
        cancelExpireMultiUser(id) {
            axios.post(this.$store.getters.getApiUrl(this.pageApi) + '/cancelExpireMultiUser', {
                id: id
            }).then(({data}) => {
                this.multi_account = data.list
                this.$store.commit('setNotification', {
                    type: 'success',
                    message: this.$ml.get('interface.saved')
                })
            })
        },
        deleteMultiUser(id) {
            axios.post(this.$store.getters.getApiUrl(this.pageApi) + '/deleteMultiUser', {
                id: id
            }).then(({data}) => {
                this.multi_account = data.list
                this.$store.commit('setNotification', {
                    type: 'success',
                    message: this.$ml.get('interface.saved')
                })
            })
        },


        saveForm() {

            let access = false
            if (this.id) {
                access = this.getPermissionSection('edit')
            } else {
                access = this.getPermissionSection('create')
            }
            if (!access) {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: 'Permission denied'
                })
                return;
            }

            let data = {
                element: {},
            }

            for (let key in this.element) {
                if (this.form_required.includes(key) && !this.element[key]) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.$ml.get('interface.empty_field') + ' - ' + this.lang.form[key]
                    })
                    return
                }

                data.element[key] = this.element[key]
                if (this.selectKeys.includes(this.getTypeForm(key))) {
                    this.getValueSelect(data.element, key)
                }
                if (this.getTypeForm(key) === 'boolean') {
                    if (this.element[key]) {
                        data.element[key] = this.element[key].id
                    }
                }
            }
            let form = new FormData()
            if (this.photo.file) {
                form.append('avatar', this.photo.file)
            }
            form.append('element', JSON.stringify(data.element))


            this.$store.commit('setLoading', true)
            axios.post(this.$store.getters.getApiUrl(this.pageApi), form)
                .then(({data}) => {
                    if (data.success) {
                        if (!this.id) {
                            this.id = data.element.id
                            this.$router.push({name: this.pageRouteEdit, params: {id: data.element.id}})
                        }
                        this.getData()
                        this.$store.commit('setNotification', {
                            type: 'success',
                            message: this.$ml.get('interface.saved')
                        })
                    } else {
                        this.$store.commit('setErrorMessage', data.message)
                    }
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        getClass(key) {
            return 'w33'
        },
        setExtraData(data) {
            this.photo.url = data.element.photo_url
            this.transactions = data.transactions
            this.subscriptions = data.subscriptions
            this.gifts = data.gifts
            this.multi_account = data.multi_account
            this.how_know = data.how_know
        },
        // Событие при перетаскивании файла
        dragoverFile(event) {
            event.preventDefault();
            event.currentTarget.classList.add('over');
        },
        // Событие при убирании курсора при перетаскивании
        dragleaveFile(event) {
            event.currentTarget.classList.remove('over');
        },
        // Событие добавления файла
        dropFile(event, type) {
            // Снимаем стиль
            event.currentTarget.classList.remove('over')
            event.preventDefault()
            // Помещаем изображение в input
            if (type === 'images') {
                this.$refs.image.files = event.dataTransfer.files
            }
            // Вызываем событие изменения
            this.onChangeFile(type)
        },
        // Изменение при добавлении файла
        onChangeFile(type) {
            let files = []
            if (type === 'images') {
                files = this.$refs.image.files
            }
            files = Array.from(files)
            files.map(file => {
                if (!this.acceptFile(file, type)) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.lang.labels.file_error.replace( /{f}/, file.name)
                    })
                } else {
                    let key = 'upload_' + Math.abs(Math.ceil(Math.random() * (1000 - 9999) + 1000))
                    if (type === 'images') {
                        let item = {
                            url: '',
                            file: file,
                        }
                        let reader = new FileReader();
                        reader.onload = (e) => {
                            item.url = e.target.result
                        }
                        reader.readAsDataURL(file);
                        this.photo = item
                    }
                }
            })
        },
        acceptFile(file, type) {
            let accept_images = [
                'image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml',
            ]
            let accept_document = [
                'image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml',
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ];
            if (type === 'images') {
                if (!accept_images.includes(file.type)) {
                    return false
                }
            } else {
                if (!accept_document.includes(file.type)) {
                    return false
                }
            }
            return true
        },
    }
}
</script>

<style scoped>

</style>
